<template>
<div id="page-search" class="container">
    <div class="row">
        <div class="col-xs-12 top">
            <!-- <div class="button button-center back" @click="back()"><i class="iconify icon:ic:round-keyboard-backspace"></i></div> -->
            <div class="options"></div>
            <div class="options"></div>
        </div>

        <div class="col-xs-12 header">
            <h3 class="page-title">Search.</h3>
            <input class="search-query" type="text" placeholder="Type in artist / song / label" v-model="searchText">
            <div class="shape"></div>
            <default-genre-and-region class="default-genre" :limitExcerptCountries="5" :limitExcerptGenres="5"></default-genre-and-region>
        </div>

        <div class="col-xs-12 content" v-show="reqData.name && reqData.available.length && reqData.genres.length">
            <song-list filter="Search" playlist-name="Search Results" :tabid="'tab-search-results'" :layout="'line'" :request-data="reqData" v-if="reqData.name" origin="search.Search"></song-list>
        </div>

        <div class="col-xs-12 info" v-show="reqData.name && (!reqData.available.length || !reqData.genres.length)">
            <span class="iconify icon:ion:alert-circle-outline"></span><br>
            <p>Please specify at least <b>one country</b> and <b>one genre</b> in the filters</p>
        </div>

        <div class="col-xs-12 info" v-show="!reqData.name">
            <span class="iconify icon:ion:search-outline"></span><br>
            <p>Start by typing in a <b>track name</b>,<br> <b>artist</b> or <b>record label</b></p>
        </div>
    </div>
</div>
</template>

<script>
export default {
    components: {
        'song-list': require('@/components/Song/List.vue').default,
        'default-genre-and-region': require('@/components/Search/Filters.vue').default,
    },

    data() {
        return {
            reqData: false,
            searchText: '',
            searchTimeout: false
        }
    }, 

    mounted() {
        if (App.allowGtag) gtag('config', 'UA-152097964-2', {
            'page_path' : "/search",
            'page_location': "/search",
            'page_title' : "Search"
        });

        //init
        var countries = [];
        var genres = [];
        $.each(App.filters.raw.countries, (i, c) => { countries.push(c.id); })
        $.each(App.filters.raw.genres, (i, g) => { genres.push(g.id); })

        this.reqData = {
            name: null,
            available: countries,
            genres: genres
        }

        this.$on('updateFilters', function(f){
            this.reqData = {
                available: f.countries,
                genres: f.genres,
                name: this.reqData.name 
            }
        });
    },

    methods: {
        back(){
            setTimeout(() => {
                if ( this.$router.history.current.name && this.$router.history.current.name != 'search'){
                    this.$router.back();
                }else{
                    this.$router.back();
                    // this.$router.push('/');
                }
            }, 300);
        },
    },

    watch: {
        searchText(){
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.reqData = {
                    available: this.reqData.available,
                    genres: this.reqData.genres,
                    name: this.searchText 
                }

                if (App.allowGtag) gtag('event', 'search_term', {
                    'event_category' : 'search',
                    'event_label' : `Searched succesufully`
                });                
            }, 750)
        }
    }
}
</script>